module.exports = __webpack_public_path__ + "img/p_sz_21.696acaca.svg";